/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import './styles.scss';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTranslation } from 'react-i18next';
import { useStudioAutoComplete } from './useStudioAutoComplete';

export default function StudioAutoComplete(props) {
  const { studios } = props;
  const { t } = useTranslation();

  const {
    handleSearchStudio, handleGoToStudioPage, handleAutoCompleteChange, searchReference, buttonDisabled,
  } = useStudioAutoComplete(props);

  return (
    <Box className="studio-autocomplete-container">
      <Autocomplete
        className="studio-autocomplete"
        disablePortal
        options={studios}
        getOptionLabel={(option) => option.studioName}
        onInputChange={handleAutoCompleteChange}
        renderInput={(params) => (
          <TextField {...params} label={t('studioSelection')} inputRef={searchReference} />
        )}
      />
      <Box className="button-container">
        <Button
          className="studio-direct"
          variant="contained"
          disabled={buttonDisabled}
          onClick={handleGoToStudioPage}
        >
          {t('openStudioSite')}
        </Button>
        <Button
          className="studio-on-map"
          variant="outlined"
          onClick={handleSearchStudio}
          endIcon={<LocationOnIcon />}
        >
          {t('map')}
        </Button>
      </Box>
    </Box>
  );
}

StudioAutoComplete.propTypes = {
  studios: PropTypes.array.isRequired,
};
